import { Flex } from '@repo/ui/Flex';
import { Checkbox } from '@repo/ui/Checkbox';
import { Text } from '../../Language/Language';
import s from './AttestationCheckbox.module.css';

export type AttestationCheckboxProps = {
  id: string;
  reasonId?: string;
  required: boolean;
  checked?: boolean;
  onChange: (checked: boolean) => void;
};

export const AttestationCheckbox = (props: AttestationCheckboxProps) => {
  const { id, reasonId, required, checked = false, onChange } = props;

  return (
    <Flex gap="g-8" alignItems="center" className={s.wrapper}>
      <Checkbox
        id={id}
        name={id}
        aria-required={required}
        checked={checked}
        onChange={(e) => onChange(e.currentTarget.checked)}
      />
      <label htmlFor={id} className={s.label}>
        <Text
          langKey={[
            `pdx.reason_selection.attestation_checkbox.${reasonId}`,
            'pdx.reason_selection.attestation_checkbox',
          ]}
        />
      </label>
    </Flex>
  );
};
